import {ArrayDataToApiListData} from '../../../global/helpers/ArrayDataToApiListData';
import request from '../../axios';

const getMyStoreAds = async ({payload}: IGetMyStoreAdsPayload) => {
  // i want to convert advertisement_type=["type1", "type2"] to advertisement_type=type1,type2
  const {search, advertisement_type, ...restPayload} = payload || {};
  const finalPayload = {
    ...restPayload,
    ...(search?.trim() ? {search: search.trim()} : {}),
    ...(advertisement_type?.length && {
      advertisement_type: ArrayDataToApiListData(advertisement_type),
    }),
  };

  const {data}: {data: IGetMyStoreAdsData[]} = await request.get(
    '/api/v2/store/my-store-advertisements',
    {
      params: {
        ...finalPayload,
      },
    },
  );
  return data;
};

export default getMyStoreAds;
